import useSelectedContact from './useSelectedContact';

const useSelectedContactType = () => {
  const { selectedContact } = useSelectedContact();
  return selectedContact ? selectedContact.type : undefined;
};

export default useSelectedContactType;
